export default "__VITE_PUBLIC_ASSET__3c97aa3a__"